var map = {
	"./1.jpg": 3900,
	"./10.jpg": 4176,
	"./11.jpg": 8509,
	"./2.jpg": 7636,
	"./3.jpg": 5006,
	"./4.jpg": 9418,
	"./5.jpg": 8034,
	"./6.jpg": 9810,
	"./7.jpg": 9729,
	"./8.jpg": 8848,
	"./9.jpg": 3714
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2744;